import type { Item } from "./Item";
import type { Proto } from "./Proto";

export interface S25ItemI<T = Item.Ids> {
    itemId?: string | number; //identifies item semantically
    itemName?: string;

    itemTypeId?: T; //identifies item type
    itemDesc?: string; //sub-name, such as title, formal name, etc
    favorite?: boolean | Proto.CharBoolean;

    txt?: string; //itemName alternative from historical code
    val?: string | number; //itemId alternative from historical code

    checked?: boolean;
    /**
     * Prevent deselection of this item
     */
    isPermanent?: boolean;
    isSecret?: boolean;

    quantity?: number; // use in  event preference
    quantityMax?: number; // use in event preference

    sortOrder?: number;

    [key: string]: any; //allow any other properties
}

export namespace S25ItemI {
    export type NumId<T = Item.Ids> = S25ItemI<T> & {
        itemId: number;
    };

    export namespace NumId {
        export type Optional<T = Item.Ids> = S25ItemI<T> & { itemId?: number };

        export function hydrate<T = Item.Ids>(item: S25ItemI<T>): NumId<T> {
            if (typeof item.itemId !== "number") {
                item.itemId = Number(item.itemId);
            }
            return item as NumId<T>;
        }
    }

    export type Typed<T> = NumId<T> & { itemTypeId: T };
}
